import {
  defineProductDimensions,
  esMrpaxePricingVersionDimension,
  esMrpaxeSelectedDimension,
} from '@orus.eu/dimensions'

import { esMrpaxeProductVersionDimension } from './es-mrpaxe-dimensions.ts'
import { esMrpaxeQuoteDimension } from './es-mrpaxe-quote-dimension.ts'

export * from './es-mrpaxe-activity-dimensions.ts'
export * from './es-mrpaxe-dimensions.ts'
export * from './es-mrpaxe-policy-item-dimensions.ts'
export * from './es-mrpaxe-quote-dimension.ts'
export * from './es-mrpaxe-subscription-ui.ts'
export * from './es-mrpaxe-ui-elements.ts'

export const esMrpaxeDimensionsModule = defineProductDimensions({
  product: 'es-mrpaxe',
  family: 'mrp',
  selectionDimension: esMrpaxeSelectedDimension,
  productVersionDimension: esMrpaxeProductVersionDimension,
  pricingVersionDimension: esMrpaxePricingVersionDimension,
  quoteV3Dimension: esMrpaxeQuoteDimension,
})
